module.exports = __webpack_public_path__ + "4c39bc4b720e1d6046b324408a0904aa.svg";